import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" No projects found ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Loading please wait... ")
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "input-field" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Name:", -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Save")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Cancel")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_button = _resolveComponent("ui-button")!
  const _component_ui_column = _resolveComponent("ui-column")!
  const _component_ui_datatable = _resolveComponent("ui-datatable")!
  const _component_ui_paginator = _resolveComponent("ui-paginator")!
  const _component_ui_inputtext = _resolveComponent("ui-inputtext")!
  const _component_ui_dialog = _resolveComponent("ui-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ui_datatable, {
      loading: $setup.loading,
      rows: 20,
      value: $setup.projects
    }, {
      header: _withCtx(() => [
        _createVNode(_component_ui_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showDialog = true))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        })
      ]),
      empty: _withCtx(() => [
        _hoisted_2
      ]),
      loading: _withCtx(() => [
        _hoisted_3
      ]),
      default: _withCtx(() => [
        _createVNode(_component_ui_column, { header: "Project" }, {
          body: _withCtx((slotProp) => [
            _createElementVNode("div", {
              onClick: ($event: any) => ($setup.viewProject(slotProp.data.projectId))
            }, _toDisplayString(slotProp.data.name), 9, _hoisted_4)
          ]),
          _: 1
        }),
        _createVNode(_component_ui_column, {
          header: "Actions",
          style: {"width":"10rem"}
        }, {
          body: _withCtx((slotProp) => [
            _createVNode(_component_ui_button, {
              class: "p-button-text",
              icon: "pi pi-search",
              onClick: ($event: any) => ($setup.viewProject(slotProp.data.projectId))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["loading", "value"]),
    _createVNode(_component_ui_paginator, {
      rows: $setup.pageSize,
      rowsPerPageOptions: [10, 20, 30],
      totalRecords: $setup.totalRecords,
      onPage: $setup.changePage
    }, null, 8, ["rows", "totalRecords", "onPage"]),
    _createVNode(_component_ui_dialog, {
      visible: $setup.showDialog,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (($setup.showDialog) = $event)),
      style: { width: '50vw' },
      header: "Add Workflow",
      modal: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createVNode(_component_ui_inputtext, {
              modelValue: $setup.newProject.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.newProject.name) = $event)),
              class: "fullwidth"
            }, null, 8, ["modelValue"]),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_ui_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.saveProject()))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_ui_button, {
            class: "p-danger",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.showDialog = false))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}